import { render, staticRenderFns } from "./stammdaten.vue?vue&type=template&id=a576c390&"
import script from "./stammdaten.vue?vue&type=script&lang=js&"
export * from "./stammdaten.vue?vue&type=script&lang=js&"
import style0 from "./stammdaten.vue?vue&type=style&index=0&id=a576c390&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports